import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16acc8c6")

_pushScopeId("data-v-16acc8c6")
const _hoisted_1 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center fs-6 fw-bold mb-2"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger fs-7 mt-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.label != '' && _ctx.lable != true)
        ? (_openBlock(), _createBlock("label", _hoisted_2, [
            _createVNode("span", {
              class: { required: _ctx.required }
            }, _toDisplayString(_ctx.label), 3)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        prop: _ctx.name,
        rules: _ctx.formRules,
        class: "input-item"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            placeholder: _ctx.translate(_ctx.placeholder),
            name: _ctx.name,
            type: _ctx.type,
            min: _ctx.min,
            onInput: _ctx.updateValue,
            onBlur: _ctx.blurValue,
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue = $event)),
            value: _ctx.value,
            disabled: _ctx.disabled
          }, null, 8, ["placeholder", "name", "type", "min", "onInput", "onBlur", "modelValue", "value", "disabled"]),
          (_ctx.showLimitMessage)
            ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.translate(_ctx.maxLengthMsg)), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["prop", "rules"])
    ])
  ]))
})